export function ReCaptchaVerify(siteKey, action, callback) {
  window.grecaptcha.ready(() => {
    window.grecaptcha.execute(siteKey, { action: action }).then((token) => {
      if (callback) callback(token);
    });
  });
}

export default ReCaptchaVerify;
